<template>
  <div
    class="tab-pane fade bg-white"
    id="_inactive"
    role="tabpanel"
    aria-labelledby="multiple-tab"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h5>Post</h5>
      <button
        :class="{
          'btn btn-primary': true,
          'disabled btn-secondary': editOnly || isDisabled
        }"
        @click.self="triggerOpenModal"
        :disabled="editOnly || isDisabled"
      >
        {{ editOnly ? "Published" : "Publish" }}
      </button>
    </div>

    <form class="container-fluid needs-validation" novalidate>
      <div
        v-for="(question, index) in questions"
        :key="index"
        class="d-flex mb-3"
      >
        <!-- Type Selection -->
        <div class="flex-shrink-0 " style="flex: 1 1 25%; width: 100%;">
          <label :for="'type-' + index" class="form-label">Type</label>
          <div style="gap: 4rem" class="d-flex flex-wrap  align-items-center">
            <div class="form-check form-check-inline mb-2 me-4">
              <input
                :disabled="editOnly || isDisabled"
                v-model="question.type"
                :value="1"
                type="radio"
                :id="'rsvp-' + index"
                :name="'type-' + index"
                class="form-check-input"
                required
              />
              <label :for="'rsvp-' + index" class="form-check-label"
                >Rating</label
              >
            </div>
            <div class="form-check form-check-inline mb-2 me-4">
              <input
                :disabled="editOnly || isDisabled"
                v-model="question.type"
                :value="2"
                type="radio"
                :id="'request-tba-' + index"
                :name="'type-' + index"
                class="form-check-input"
                required
              />
              <label :for="'request-tba-' + index" class="form-check-label"
                >Yes or No</label
              >
            </div>
            <div class="form-check form-check-inline mb-2">
              <input
                :disabled="editOnly || isDisabled"
                v-model="question.type"
                :value="3"
                type="radio"
                :id="'request-tbk-' + index"
                :name="'type-' + index"
                class="form-check-input"
                required
              />
              <label :for="'request-tbk-' + index" class="form-check-label"
                >Open Text</label
              >
            </div>
          </div>
          <div v-if="question.typeError">
            <small class="text-danger">{{ question.typeError }}</small>
          </div>
        </div>

        <!-- Question Input -->
        <div style="flex: 1 1 75%;">
          <label :for="'question-' + index" class="form-label">Question</label>
          <div class="d-flex justify-content-center align-items-center">
            <input
              :disabled="editOnly || isDisabled"
              v-model="question.question"
              type="text"
              :id="'question-' + index"
              class="form-control me-2 mr-3"
              placeholder="Enter a question..."
              required
            />

            <i
              class="fa fa-trash"
              aria-hidden="true"
              @click="deleteQuestion(question.id)"
              :class="{ 'disabled-icon hidden': editOnly || isDisabled }"
              :style="{
                pointerEvents: editOnly || isDisabled ? 'none' : 'auto',
                opacity: editOnly || isDisabled ? 0.5 : 1,
                color: editOnly || isDisabled ? '#ccc' : '#AC8400'
              }"
            ></i>
          </div>
          <div v-if="question.questionError">
            <small class="text-danger">{{ question.questionError }}</small>
          </div>
        </div>
      </div>

      <!-- Add Question Button -->
      <button
        type="button"
        :class="{
          'btn btn-primary rounded mr-2': true,
          'btn-secondary disabled': editOnly || isDisabled
        }"
        :disabled="editOnly || isDisabled"
        @click.prevent="addQuestion"
      >
        Add Question
      </button>
      <!-- <button type="button" :class="{ 'btn btn-primary rounded': true, 'hidden': !editOnly }"
                :disabled="!editOnly" @click.prevent="update">
                Update
            </button> -->
    </form>
    <div v-if="editOnly">
      <div class="mt-4 mb-4">
        <TableComponent
          :id="'my_activity_feedback_tbl'"
          title=""
          :headers="[
            { label: 'No.', width: '5%' },
            { label: 'Questions', width: '60%' },
            { label: 'Type', width: '20%' }
          ]"
          :data="questions"
          :fields="['index', 'question', 'type_name']"
          :buttons="[
            {
              label: 'View Answer',
              action: row => fetchFeedback(row.id),
              color: 'primary'
            },
            {
              label: 'Edit',
              action: row => editQuestion(row),
              color: 'success',
              disabled: isDisabled
            }
          ]"
        />
      </div>
      <AnswerTable :data="feedbackQuestion" />
    </div>
  </div>
</template>

<script>
import TableComponent from "./table.vue";
import AnswerTable from "./answer.vue";
import { showFeedback } from "../../../services/MyActivityService";
import { error } from "jquery";

export default {
  name: "Feedback",

  components: {
    TableComponent,
    AnswerTable
  },

  props: {
    my_activity_id: {
      type: Number,
      required: true
    },

    data: {
      type: Array,
      default: []
    },

    editOnly: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      questions: [
        {
          my_activity_id: Number(this.my_activity_id),
          id: Date.now(),
          type: 1,
          question: "",
          error: ""
        }
      ],
      question: [],
      feedbackQuestion: []
    };
  },

  watch: {
    data(newData) {
      if (newData && Object.keys(newData).length > 0) {
        this.questions = newData;
      } else {
        this.editOnly = false;
      }
    },
    questions: {
      deep: true,
      handler(newVal, oldVal) {
        this.destroyDatatable();
      }
    }
  },

  created() {
    if (this.data && Object.keys(this.data).length > 0) {
      this.editOnly = true;
    }
  },

  methods: {
    async fetchFeedback(id) {
      const response = await showFeedback(id);

      if (response.data.data) {
        this.feedbackQuestion = response.data.data;
      }
    },

    addQuestion(index) {
      const newQuestion = {
        my_activity_id: Number(this.my_activity_id),
        id: Date.now(),
        type: 1,
        question: ""
      };
      this.questions.push(newQuestion);
    },

    deleteQuestion(id) {
      console.log("delete id: ", id);
      this.questions = this.questions.filter(question => question.id !== id);
    },

    triggerOpenModal() {
      this.questions.forEach((question, index) => {
        if (!question.question) {
          this.$set(
            this.questions[index],
            "questionError",
            "Question is required"
          );
        } else {
          this.$set(this.questions[index], "questionError", null);
        }
        if (!question.type) {
          this.$set(this.questions[index], "typeError", "Type is required");
        } else {
          this.$set(this.questions[index], "typeError", null);
        }
        if (!question.questionError && !question.typeError) {
          this.$emit("feedback", this.questions);
        }
      });
    },

    editQuestion(question) {
      this.$emit("editData", question);
    },

    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`)
          .DataTable()
          .destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          }
        ]
      });
    },

    destroyDatatable() {
      ["my_activity_feedback_tbl"].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`)
            .DataTable()
            .destroy();
        }
      });

      this.$nextTick(() => {
        this.loadDatatable("my_activity_feedback_tbl");
      });
    },

    loadTable() {
      $("#my_activity_feedback_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"],
        bDestroy: true
      });
    }
  },

  mounted() {}
};
</script>

<style>
.disabled-icon {
  color: #ccc;
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.hidden {
  display: none;
}
</style>
